import React, { useEffect, useState, SyntheticEvent } from 'react';
import defaultImage from '../../assets/default.jpg';
import { ImageDimensions } from '../../types';
import { StyledImage } from '../Styled';

interface IStyledImageWrapper {
  src: string;
  width?: number;
  height?: number;
  borderRadius?: string;
  alt?: string;
  isVisible?: boolean;
  className?: string;
  setDefaultImageDimensions?: (imageDimensions: ImageDimensions) => void;
}

export const ExemplarImage: React.FC<IStyledImageWrapper> = (props): JSX.Element => {
  const { className, src, alt, width, height, borderRadius, isVisible, setDefaultImageDimensions, ...rest } = props;

  const [isError, setError] = useState(false);

  const showDefault = isError || !src;

  useEffect(() => {
    setError(false);
  }, [src]);

  const handleError = () => setError(true);

  const setImageAndExemplarDimensions = (event: SyntheticEvent) => {
    if (!setDefaultImageDimensions) {
      return;
    }

    const image = event.target as HTMLImageElement;
    const firstParent = image.offsetParent as HTMLDivElement;
    const secontParent = firstParent.offsetParent as HTMLDivElement;
    const thirdParent = secontParent.offsetParent as HTMLDivElement;

    setDefaultImageDimensions({
      width: image.clientWidth,
      height: image.clientHeight,
      exemplarWidth: thirdParent.clientWidth,
      exemplarHeight: thirdParent.clientHeight,
    });
  };

  return (
    <StyledImage
      src={!showDefault ? src : (defaultImage as string)}
      alt={alt}
      width={width}
      height={height}
      borderRadius={borderRadius}
      isVisible={isVisible}
      className={className}
      onError={handleError}
      onLoad={setImageAndExemplarDimensions}
      {...rest}
    />
  );
};
